import React from 'react';
import styles from './Blocks.module.css';

const FooterItemContainer = (props) => {
  const {children, className} = props
  return <div className={`${styles.item_container} ${className} flex-wrap justify-content-start d-flex w-100 align-items-start`}>{children}</div>;
};

export default FooterItemContainer;
